export default __webpack_public_path__ + "static/media/square.3ff2a2f2.svg";